import React from 'react';
import I18n from 'i18n-js';

import AddressFormFieldsContainer, { ICoreAddress } from './address_form_fields_container';
import { ICountry } from '../schemas/core-schema';

import { RCTooltip } from '@reverbdotcom/commons/src/rc/RCTooltip';

interface IProps {
  address: ICoreAddress;
  countries: ICountry[];
  fieldPrefix: string;
}

export default function CheckoutShippingAddressFormFields({ address, countries, fieldPrefix }: IProps) {
  const tooltip = <RCTooltip text={I18n.t('discovery.checkoutShippingAddressFormFields.tooltip')}>
    {I18n.t('discovery.checkoutShippingAddressFormFields.phoneLabelText')}
  </RCTooltip>;

  return (
    <AddressFormFieldsContainer
      address={address}
      countries={countries}
      fieldPrefix={fieldPrefix}
      requiredFieldsOverrides={['phone']}
      phoneLabel={tooltip}
    />
  );
}
